export default {
  APP: {
    NAME: 'app',
    LOADING: 'loading'
  },
  ADMIN: {
    NAME: 'admin',
    OBJ_INFO: 'objInfo',
    OBJ_DETAIL: 'objDetail',
    SELECT_ONE: 'selectOne',
    NEW_OBJ: 'newObj',
    GET_OBJ: 'getObj',
    LIST: 'list',
    ROWS: 'rows',
    COUNT: 'count'
  },
  AUTH: {
    NAME: 'auth',
    REFRESH_TOKEN: 'refreshToken',
    LOGIN: 'login',
    LOGOUT: 'logout',
    OBJ_INFO: 'objInfo',
    INIT: 'init',
    USER: 'user',
    TOKEN: 'token',
    CLAIMS: 'claims',
    SESSION_LOADED: 'sessionLoaded',
    FIREBASE_LOADED: 'firebaseLoaded'
  }
}



// WEBPACK FOOTER //
// ./src/constants/store.js